// import { axiosPrivate } from "api/axios";
// import { AUTH_TOKEN, REFRESH_TOKEN } from "constants/AuthConstant";

// const ReportService = {};

// ReportService.getOneReportBabysitter = function (id) {
//   return axiosPrivate({
//     method: "get",
//     url:`/Reports/babysitter/${id}`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// ReportService.getOneReportParent = function (id) {
//   return axiosPrivate({
//     method: "get",
//     url: `/Reports/parent/${id}`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// ReportService.getAllBabysittersReports = function (id) {
//   return axiosPrivate({
//     method: "get",
//     url: `/Reports/reportedBabysitters/${id}`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };

// ReportService.getAllParentsReports = function (id) {
//   return axiosPrivate({
//     method: "get",
//     url: `/Reports/reportedParents/${id}`,
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
//     },
//   });
// };


// export default ReportService;





import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const ReportService = {};

ReportService.getOneReportBabysitter = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/Reports/babysitter/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ReportService.getOneReportParent = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/Reports/parent/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ReportService.getAllBabysittersReports = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/Reports/reportedBabysitters/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

ReportService.getAllParentsReports = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/Reports/reportedParents/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    },
  });
};

export default ReportService;